import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import * as Common from "../Common";
import * as Picklist from "../Picklist";
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import Dialog from "../Dialog";
import $ from "jquery";




function Tran_passport_form(props) {
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [name, setName] = useState("");
    const [gender, setGender] = useState("M");
    const [dob, setDob] = useState("");
    const [nationality, setNationality] = useState("");
    // const [natCode, setNatCode] = useState()
    const [issuingCountry, setIssuingCountry] = useState("");
    // const [cntCode, setCntCode] = useState()
    const [passportNumber, setPassportNumber] = useState("");
    const [expiryDate, setExpiryDate] = useState("");
    const [state, setState] = useState("");
    const [stateCode, setStateCode] = useState("");

    const [panNumber, setPanNumber] = useState("");
    const [tdsDeducting, setTdsDeducting] = useState(false);
    const [aadhaarNumber, setAadhaarNumber] = useState("");
    const [aadhaarEidNumber, setAadhaarEidNumber] = useState("");
    const [address, setAddress] = useState("");
    const [pincode, setPincode] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    // const [showIndividualBtn, setShowIndividualBtn] = useState(false);

    const sid = sessionStorage.getItem("sessionId");
    const nameInputRef = useRef(null);

    useEffect(() => {
        handleClear();
    }, [])
    useEffect(() => {
        // Focus on the name input field when the modal opens
        if (props.show) {
            setTimeout(() => {
                if (nameInputRef.current) {
                    nameInputRef.current.focus();
                }
            }, 100);
        }
    }, [props.show]);

    const handleClear = () => {
        setName("");
        setGender("M");
        setDob("");
        setNationality("");
        setIssuingCountry("");
        setPassportNumber("");
        setExpiryDate("");
        setState("");
        setPanNumber("");
        setTdsDeducting(false);
        setAadhaarNumber("");
        setAadhaarEidNumber("");
        setAddress("");
        setPincode("");
        setMobileNumber("");
    };

    function handleProceed() {
        $('.loader').show();
        let msg = [];
        msg.push(Common.getMessage("MSG0006"));
        !passportNumber && msg.push("Passport Number required");
        !name && msg.push("Name required");
        !dob && msg.push("Dob required");
        !nationality && msg.push("Nationality required");
        (props?.type === 'SP' && nationality === 'IND' && !panNumber) && msg.push("Pancard required");
        !issuingCountry && msg.push("Issueing Country required");
        !address && msg.push("Address required");
        address && address.length < 10 && msg.push("Address length must be at least 10 characters.");
        !pincode && msg.push("Pincode required");
        pincode && pincode.length !== 6 && msg.push("Pincode must be 6 characters long");
        !mobileNumber && msg.push("Mobile Number required");
        // (nationality === 'IND' && !panNumber) && msg.push("Pan Number required");
        if (msg.length > 1) {
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let dobYMD = dob.split('/').reverse().join('-');
            let expDateYMD = expiryDate.split('/').reverse().join('-');
            console.log(dob)
            const obj = {
                name: name,
                gender: gender,
                dob: dobYMD,
                nationality: nationality,
                issueContry: issuingCountry,
                passportNumber: passportNumber,
                expiryDate: expDateYMD,
                panNumber: panNumber,
                state: state.id ? state.id.split('^')[1] : 0,
                address: address,
                pincode: pincode,
                mobileNumber: mobileNumber,
            }
            Common.callApi(Common.apiPassport, [sid, 'findIndividualByPassport', JSON.stringify(obj)], result => {
                const response = JSON.parse(result);
                $('.loader').hide();
                console.log(typeof response.indivisulaSrno)
                if (response.indivisulaSrno != 0) {
                    props.proceedHandler(false, response.indivisulaSrno)
                    props.onHide();
                } else {
                    setMsgText(response.msg)
                    setMsgBox(true);
                }
            })
        }
    }
    const handleStateValue = (value) => {
        setState(value);
        const stt = value.id.split('^');
        setStateCode(stt[1]);
    }


    return (
        <Modal show={props.show} onHide={props.onHide} size="xl" centered >
            <Modal.Header closeButton>
                <Modal.Title>Passport Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Group controlId="name">
                                <Form.Label>Name<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={name}
                                    ref={nameInputRef}  // Attach ref for auto-focus
                                    onChange={(e) => Common.validateAlpValue(e.target.value, setName)}
                                    placeholder="Enter name"
                                    autoComplete="off"
                                    autofocus
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Gender</Form.Label>
                                <Form.Select value={gender} onChange={e => setGender(e.target.value)}
                                    required>
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Date of Birth</Form.Label>
                                {/* <DatePicker className="form-control"
                                    selected={dob}
                                    onChange={(date) => setDob(date)}
                                    maxDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                /> */}
                                <Form.Control className="form-control"
                                    type="text"
                                    selected={dob}
                                    onChange={(e) => setDob(e.target.value)}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label>Nationality<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={nationality}
                                    maxLength={3}
                                    onChange={(e) => setNationality(e.target.value.toUpperCase())}
                                    autoComplete="off"
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Issuing Country<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={issuingCountry}
                                    onChange={(e) => setIssuingCountry(e.target.value.toUpperCase())}
                                    // autoComplete="off"
                                    autoComplete="new-password"
                                    maxLength={3}

                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="passportNumber">
                                <Form.Label>Passport No<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={passportNumber}
                                    onChange={(e) => setPassportNumber(e.target.value)}
                                    onBlur={issuingCountry === 'IND' && ((e) => Common.validatePassport(e.target.value, setPassportNumber))}
                                    placeholder="Enter passport number"
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <Form.Group>
                                <Form.Label>Expiry Date<span className=" text-danger">*</span></Form.Label><br></br >
                                {/* <DatePicker className="form-control"
                                    selected={expiryDate}
                                    onChange={(date) => setExpiryDate(date)}
                                    minDate={new Date()}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                /> */}
                                <Form.Control className="form-control"
                                    type="text"
                                    selected={expiryDate}
                                    onChange={(e) => setExpiryDate(e.target.value)}
                                    autoComplete="off"
                                />

                            </Form.Group>
                        </Col>
                        {/* {nationality === 'IND' && <span className="text-danger">*</span>} */}
                        <Col >
                            <Form.Group controlId="panNumber">
                                <Form.Label>PAN Number </Form.Label>
                                <Form.Control
                                    type="text"
                                    value={panNumber}
                                    onChange={(e) => setPanNumber(e.target.value)}
                                    onBlur={(e) => Common.validatePan(e.target.value, setPanNumber)}
                                    placeholder="Enter PAN number"
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {/* <Form.Check
                        type="checkbox"
                        label="TDS Deducting Party"
                        checked={tdsDeducting}
                        onChange={(e) => setTdsDeducting(e.target.checked)}
                    /> */}
                    <Row className="mt-3">
                        <Col md={4}>
                            <Form.Group controlId="address">
                                <Form.Label>Address<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    minLength={10}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    placeholder="Enter address"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="pincode">
                                <Form.Label>Pincode<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={pincode}
                                    maxLength={6}
                                    minLength={6}
                                    onChange={(e) => setPincode(e.target.value)}
                                    placeholder="Enter pincode"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="mobileNumber">
                                <Form.Label>Mobile Number<span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={mobileNumber}
                                    maxLength={15}
                                    minLength={10}
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    placeholder="Enter mobile number"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleProceed}>Proceed</Button>
                <Button variant="secondary" onClick={handleClear}>Clear</Button>
                <Button variant="danger" onClick={props.onHide}>Close</Button>
                {/* {showIndividualBtn && <Button variant="primary" onClick={props.onHide}>Add New Individual</Button>} */}
            </Modal.Footer>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </Modal>
    );
}

export default Tran_passport_form;
